class ProductSwatchGrouping extends HTMLElement {
  constructor() {
    super();
    this.debug = false; // Set to true for debugging
    this.displayedColors = new Set();
  }

  connectedCallback() {
    this.eventId = this.dataset.eventId;

    this.querySelectorAll("[js-request-new-product]").forEach((swatch) => {
      swatch.addEventListener("click", this.handleSwatchClick.bind(this));
      swatch.addEventListener("mouseenter", () => {
        const preloadImage = new Image();
        preloadImage.src = this.ensureImageResolution(
          swatch.dataset.productImage
        );
      });
    });
  }

  ensureImageResolution = (imageUrl) => {
    if (!imageUrl) return "";
    return imageUrl.includes("_600x.jpg")
      ? imageUrl
      : imageUrl.replace(".jpg", "_600x.jpg");
  };

  handleSwatchClick(event) {
    // const allSwatches = this.querySelectorAll('.product-swatch__image-wrapper');
    const allSwatches = this.querySelectorAll(".product-swatch");
    allSwatches.forEach((btn) => btn.classList.remove("is-active"));
    event.currentTarget.classList.add("is-active");
    const currentSwatch = event.currentTarget;
    if (this.debug) {
      console.log("ProductSwatchGrouping click - eventId:", this.eventId);
      console.log("Badge data:", currentSwatch.dataset.productTagBadge);
    }
    const eventDetails = {
      eventId: this.eventId,
      productID: currentSwatch.dataset.productId,
      handle: currentSwatch.dataset.productHandle,
      title: currentSwatch.dataset.productTitle,
      price: Number(currentSwatch.dataset.productPrice),
      compareAtPrice: Number(currentSwatch.dataset.productCompareAtPrice),
      url: `/products/${currentSwatch.dataset.productHandle}`,
      image: currentSwatch.dataset.productImage,
      imageAlt: currentSwatch.dataset.productImageAlt,
      hoverImage: currentSwatch.dataset.productHoverImage,
      hoverImageAlt: currentSwatch.dataset.productHoverImageAlt,
      messageTag: currentSwatch.dataset.productMessageTag || null,
      tagBadge:
        currentSwatch.dataset.productTagBadge === "" ||
        currentSwatch.dataset.productTagBadge === "null" ||
        currentSwatch.dataset.productTagBadge === "undefined"
          ? null
          : currentSwatch.dataset.productTagBadge,
    };
    const customEvent = new CustomEvent("product-card:change", {
      detail: eventDetails,
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(customEvent);

    const productCard = this.closest("product-card");
    productCard?.swatchClicked(eventDetails);

    // Message tag updates are now handled by React CustomProductCard via product-card:change event
  }

  // Message tag functionality has been centralized to React CustomProductCard component
  // to prevent duplication and race conditions during swatch changes
}

customElements.define('product-swatch-grouping', ProductSwatchGrouping);
